import { render, staticRenderFns } from "./storeIntegral.vue?vue&type=template&id=7a85456c&scoped=true"
import script from "./storeIntegral.vue?vue&type=script&lang=js"
export * from "./storeIntegral.vue?vue&type=script&lang=js"
import style0 from "./storeIntegral.vue?vue&type=style&index=0&id=7a85456c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a85456c",
  null
  
)

export default component.exports